export const ROLE_OPTIONS = [
    { label: "admin", value: "role_rtL:BY:(tY" },
    { label: "manager", value: "role_C$VKrq_+$z" },
    // { label: "hr", value: "role_Rkr_+Y%_a%" },
    { label: "employee", value: "role_dtFe_2T7M)" },
  ];

export const appSecret = process.env.REACT_APP_SECRET_KEY